export default __webpack_public_path__ + "static/media/2.25bb9ac7.png";